import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import { isMobile } from '../utils/MobileCheck';

import { ICategoryMst } from '../actions/search';

interface ITreeProps extends React.Props<{}>, IMyProps {}

interface ITreeState {
	open: boolean;
}

/**
 * カテゴリツリー
 * @param props
 */
class CareerTopicTree extends React.Component<ITreeProps, ITreeState> {
	public constructor(props: ITreeProps) {
		super(props);

		this.state = {
			open: true,
		};
	}

	public render() {
		const { category } = this.props;
		const { treeChildren, level, text } = category;
		let itemName = '';
		if (isMobile() && text.length > 9) {
			itemName = text.substring(0, 9) + '....';
		} else {
			itemName = text;
		}
		const checked = this.isChecked();
		return (
			<List
				component="nav"
				style={{
					paddingLeft:
						level === 1 || (isMobile() && level > 2) ? 0 : 40,
				}}
			>
				<ListItem button={true} onClick={this.toggleCheckbox}>
					<Checkbox checked={checked} />
					{isMobile() && (
						<Tooltip title={text} placement="top-start">
							<ListItemText
								inset={true}
								primary={itemName}
								style={{ paddingLeft: '10px' }}
							/>
						</Tooltip>
					)}
					{!isMobile() && (
						<ListItemText inset={true} primary={itemName} />
					)}
					{treeChildren &&
						treeChildren.length !== 0 &&
						(this.state.open ? (
							<ExpandLess onClick={this.toggleTree} />
						) : (
							<ExpandMore onClick={this.toggleTree} />
						))}
				</ListItem>
				{treeChildren &&
					treeChildren.map(
						(node: ICategoryMst, i: number): JSX.Element => (
							<Collapse
								key={i}
								in={this.state.open}
								timeout="auto"
								unmountOnExit={true}
							>
								<CareerTopicTree
									key={i}
									category={node}
									onChangeCheckbox={
										this.props.onChangeCheckbox
									}
									selectedCategories={
										this.props.selectedCategories
									}
								/>
							</Collapse>
						)
					)}
			</List>
		);
	}

	protected toggleTree = (e: React.MouseEvent<SVGSVGElement>) => {
		e.stopPropagation();
		this.setState({ open: !this.state.open });
	};

	protected toggleCheckbox = (e: React.MouseEvent<HTMLElement>) => {
		const checked = this.isChecked();
		this.props.onChangeCheckbox(!checked, this.props.category);
	};

	protected isChecked = () => {
		let checked = false;
		for (const category of this.props.selectedCategories) {
			if (category.id === this.props.category.id) {
				checked = true;
				break;
			}
		}
		return checked;
	};
}

interface IMyProps {
	category: ICategoryMst;
	onChangeCheckbox: (checked: boolean, category: ICategoryMst) => void;
	selectedCategories: ICategoryMst[];
}

export default CareerTopicTree as React.ComponentType<IMyProps>;



// WEBPACK FOOTER //
// ./src/components/CareerCategoryTree.tsx